const localAnalyticsHelper = {
  track() {
    return undefined;
  },
  page() {
    return undefined;
  },
};

export default localAnalyticsHelper;
